import React from 'react';
const FormSection = ({ children, gridElementMinWidth, gridElementMaxWidth, gridFillMode, ...props }) => {
    const finalGridElementMinWidth = gridElementMinWidth ?? '10rem';
    const finalGridElementMaxWidth = gridElementMaxWidth ?? '18.75rem';
    const finalGridFillMode = gridFillMode ?? 'auto-fill';
    return (React.createElement("div", { className: 'form-section', style: {
            gridTemplateColumns: gridElementMinWidth || gridElementMaxWidth || gridFillMode
                ? `repeat(${finalGridFillMode}, minmax(${finalGridElementMinWidth}, ${finalGridElementMaxWidth})`
                : '1fr',
        }, ...props }, children));
};
export default FormSection;
